import {
  WAIT_FOR_AUTH_SUCCEED,
  FETCH_QR_CODE_SUCCEED,
  LOGIN_NORMAL_SUCCEED,
  LOGIN_QR_1_SUCCEED,
  LOGIN_QR_2_SUCCEED, LOGIN_QR_2_FAILED, LOGIN_QR_3_FAILED, LOGIN_QR_3_SUCCEED,
} from '../actions/login/action_types';
import { UPDATE_USER_INFO_SUCCEED } from '../actions/user/action_types';

export default (state = {
  user: {},
  preUser: {},
  qrStep1: {},
  qrStep2: {},
  session: {},
  expired: true,
  // isTableLoading: false,
}, action) => {
  switch (action.type) {
    case FETCH_QR_CODE_SUCCEED:
      return {
        ...state,
        preUser: action.data,
        // isTableLoading: false,
      };
    case WAIT_FOR_AUTH_SUCCEED:
      return {
        ...state,
        user: action.data,
        // isTableLoading: false,
      };
    case UPDATE_USER_INFO_SUCCEED:
      return {
        ...state,
        user: action.data,
      };
    case LOGIN_QR_1_SUCCEED:
      return {
        ...state,
        qrStep1: action.params.data,
        expired: false,
      };
    case LOGIN_QR_2_SUCCEED:
      return {
        ...state,
        qrStep2: action.params.data,
      };
    case LOGIN_QR_2_FAILED:
      return {
        ...state,
        expired: true,
      };
    case LOGIN_QR_3_FAILED:
      return {
        ...state,
        qrStep2: {},
        expired: true,
      };
    case LOGIN_QR_3_SUCCEED:
      return {
        ...state,
        qrStep2: {},
        expired: true,
      };
    default:
      return {
        ...state,
      };
  }
};
